import React from "react";
import { fmtDateTime } from "@/lib/format";

export const CreatorInfo = ({ record, kind }) => <div className="text-xs text-slate-500 border-t border-slate-100 pt-3" data-testid={`${kind}-creator`}>
  Created by <span className="text-slate-900 font-medium">{record.creator?.name || record.creator?.email || (record.created_by ? `Unknown user (${record.created_by})` : "Not recorded")}</span>
  {record.creator?.email && <span className="ml-1">· {record.creator.email}</span>}
  <span className="block mt-1 font-mono" data-testid={`${kind}-created-at`}>{fmtDateTime(record.created_at)}</span>
</div>;
